export const BDP_FLOW = "BDP";
export const HDP_BASIC_FLOW = "HDPBasic";
export const HDP_FULL_FLOW = "HDPFull";
export const HDP_POST_SUBMIT_FLOW = "HDPPostSubmit";
export const HDP_MESSAGE_SCREENING_FLOW = "HDPMessageScreening";
export const HDP_LISTING_AGENT_FLOW = "HDPListingAgent";
